module.exports = __webpack_public_path__ + "img/1_no.b903625d.svg";